<template>
	<div class="sheet-backdrop">
		<f7-sheet :opened="show" @sheet:closed="closePeriodSelect" backdrop :params="{backdropEl:$el}" style="height: 18rem;">
			<f7-toolbar class="jxc_bottom_line" style="background-color: white;">
				<div class="left dz-font-size-14 dz-p7" @click="closePeriodSelect">取消</div>
				<div class="title dz-font-size-18">请选择期间</div>
				<div class="right dz-font-size-14 dz-p7 fg-color-primary" @click="emit">确定</div>
			</f7-toolbar>
			<f7-page-content style="padding: 0.625rem 1.875rem;">
				<div v-for="(item, index) in list" :key="index" class="flex-between" style="height: 3.4375rem;">
					<div class="dz-font-size-18" style="padding-right: 1.25rem;">{{item.Year+"年："}}</div>
					<div v-for="(innerItem, i) in item.InnerList" :key="i" class="dz-font-size-14" @click="select(item.Year, innerItem)">
						<div class="year_box" :class="{'year_checked':innerItem.Key==Pid,'year_unselected':innerItem.Key<0}">{{innerItem.Value}}</div>
					</div>
				</div>
			</f7-page-content>
		</f7-sheet>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				list: [],
				Pid: "",
				Pname: "",
			}
		},
		props: {
			// 是否显示弹框
			show: Boolean,
			// 选中数据的key
			value: String,
			// 选中数据的name
			label: String,
		},
		mounted() {
			this.$f7.emit('initPageData', this.initData);
		},
		methods: {
			initData() {
				var r = this.store_PeriodSection;
				let firstYear = r[0].Value.substring(0, 4);
				let firstMonth = r[0].Value.substring(6, r[0].Value.length - 1);
				let firstKey = r[0].Key;
				this.$set(this, "Pid", firstKey);
				this.$set(this, "Pname", firstYear + "年" + (firstMonth > 6 ? "下半年" : "上半年"));
				this.emit();
				let endYear = r[r.length - 1].Value.substring(0, 4);
				let endMonth = r[r.length - 1].Value.substring(6, r[r.length - 1].Value.length - 1);
				let endKey = r[r.length - 1].Key;
				for (var i = firstYear; i >= endYear; i--) {
					this.list.push({
						Year: i,
						InnerList: [{
							"Value": "上半年",
							"Key": 0,
						}, {
							"Value": "下半年",
							"Key": 0,
						}]
					});
				}
				let len = this.list.length;
				if (endMonth > 6) {
					this.$set(this.list[len - 1].InnerList[0], "Key", -1);
					this.$set(this.list[len - 1].InnerList[1], "Key", endKey);
				} else {
					this.$set(this.list[len - 1].InnerList[0], "Key", endKey);
				}
				if (firstMonth > 6) {
					this.$set(this.list[0].InnerList[1], "Key", firstKey);
				} else {
					this.$set(this.list[0].InnerList[1], "Key", -1);
					this.$set(this.list[0].InnerList[0], "Key", firstKey);
				}
				this.list.forEach(item => {
					for (var i = 1; i >= 0; i--) {
						if (item.InnerList[i].Key == 0) {
							firstKey = firstKey - 6;
							this.$set(item.InnerList[i], "Key", firstKey + "");
						}
					}
				});
			},
			select(year, item) {
				if (item.Key < 0) return;
				this.$set(this, "Pid", item.Key);
				this.$set(this, "Pname", year + "年" + item.Value);
			},
			emit() {
				this.$emit("input", this.Pid.toString());
				this.$emit("update:label", this.Pname);
				this.$emit("update:show", false);
			},
			closePeriodSelect() {
				this.$emit("update:show", false);
			},
		}
	}
</script>

<style scoped="scoped" lang="less">
	.year_box {
		width: 5rem;
		text-align: center;
		padding: 0.1875rem 0 0.125rem;
	}

	.year_checked {
		background-color: @primary-color;
		border-radius: 0.25rem;
		color: white;
	}

	.year_unselected {
		color: #9D9EAE;
	}

	.quarter_box {
		width: 3.75rem;
		height: 1.5625rem;
		text-align: center;
		line-height: 1.5625rem;
	}

	.quarter_checked {
		background-color: @primary-color;
		border-radius: 0.25rem;
		color: white;
	}

	.quarter_unselected {
		color: #DADADA;
	}

	.tab_flag {
		width: 2rem;
		height: 0.125rem;
		background-color: @primary-color;
		border-radius: 0.125rem;
		position: absolute;
		bottom: 0.0625rem;
	}
</style>
